export type InvoiceSection = "pending_manual" | "pending_auto" | "completed";

export type InvoiceStatus =
  | "flagged"
  | "awaiting_review"
  | "scheduled"
  | "sending"
  | "sent"
  | "failed";

export interface MockInvoice {
  id: number;
  booking_id: number;
  booking_no: string;
  customer_name: string;
  is_partner: boolean;
  partner_name?: string | null;
  end_customer_name?: string | null;
  // amount is gross (incl VAT) — the figure that will actually be billed.
  // amount_excl_vat is the net subtotal. Both come from the canonical VAT
  // columns server-side; total_price is intentionally not used because it's
  // populated inconsistently by the customer-portal vs staff booking flows.
  amount: number;
  amount_excl_vat: number;
  currency: string;
  status: InvoiceStatus;
  section: InvoiceSection;
  flag_reason?: string | null;
  scheduled_send_at?: string | null;
  last_action_at: string;
  last_action_by?: string | null;
  note?: string | null;
  invoice_number?: string | null;
}

export const STATUS_LABELS: Record<InvoiceStatus, string> = {
  flagged: "Flagged",
  awaiting_review: "Awaiting review",
  scheduled: "Scheduled",
  sending: "Sending",
  sent: "Sent",
  failed: "Failed",
};

export const SECTION_LABELS: Record<InvoiceSection, string> = {
  pending_manual: "Pending Manual",
  pending_auto: "Pending Auto Send",
  completed: "Sent / Failed",
};

export function statusBadgeClass(status: InvoiceStatus): string {
  switch (status) {
    case "flagged":
      return "bg-amber-100 text-amber-800 border-amber-200";
    case "awaiting_review":
      return "bg-orange-100 text-orange-800 border-orange-200";
    case "scheduled":
      return "bg-blue-100 text-blue-800 border-blue-200";
    case "sending":
      return "bg-purple-100 text-purple-800 border-purple-200";
    case "sent":
      return "bg-green-100 text-green-800 border-green-200";
    case "failed":
      return "bg-red-100 text-red-800 border-red-200";
  }
}
